export const rejectionReasonStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  padding: 2,
};
